//HeroSection.js
///////////////////////////////
//React & Material
import { motion } from "framer-motion";
import React, { useState } from 'react';
import Col from 'react-bootstrap/Col';
//Bootstrap Imports
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import { RandomReveal } from "react-random-reveal";
//Plugins
import styled from 'styled-components';
import Melb from '../media/melbourne.jpg';
import ScrollSvg from '../media/scroll.svg';
import { useMediaQuery } from 'react-responsive'

// const Projects = require('../projects/work.json')
//////////////////////////////
//Styled components
const FullHeightContainer = styled.div`
  height:100vh;
  // border-style: solid;
  // border-color: #36FFC1;


  @media only screen and (max-width: 767px) {
   padding-left:15vw;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    padding-left:10vw;
  }
`
const HalfHeightContainer = styled.div`
  height:80vh;
  // border-style: solid;
  // border-color: #36FFC1;
`

const CustomHeightContainer = styled.div`
  height:60vh;
  // border-style: solid;
  // border-color: #36FFC1;
`
const HeroWrapper = styled(Container)`
  margin-top:20vh;
  @media only screen and (min-width: 768px) {
 
  }

  @media only screen and (max-width: 767px) {
    margin-top:14vh;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-top:14vh;
  }
`
const HeadingWrapper = styled(motion.div)`
`
const HeroText = styled.h1`
  text-align: left;
  padding:5px 0px;
  font-weight: 700;
  font-size: 86px;
  line-height: 104.9%;
  z-index:2;
  display:inline-block;
  position:relative;

  @media only screen and (min-width: 768px) {
    /* tablets and desktop */
  }

  @media only screen and (max-width: 767px) {
    font-size: 44px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 44px;
  }


`
const HeroSubheading = styled.h3`
  text-align: ${props => props.align || "left"};
  margin-top:70px;
  font-style: italic;
  font-weight: normal;
  font-size: 60px;
  line-height: 104.9%;
  display:inline-block;

  @media only screen and (max-width: 767px) {
    font-size: 35px;
    margin-top:30px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 35px;
    margin-top:30px;
  }
`
const SubHeadingDeco = styled.div`
  font-style: italic;
  font-weight: normal;
  font-size: 137px;
  color: #36FFC1; 
  line-height: 20%;
  display:inline-block;

  @media only screen and (max-width: 767px) {
    font-size: 60px;
    line-height: 40%;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: 60px;
    line-height: 40%;
  }
`
const HeadingDeco = styled.div`
  position:relative;
  left:-40%;
  top:10%;
  z-index:1;
  width: 312px;
  height: 35px;
  background: #36FFC1;
  display:inline-block;
`
const DescWrapper = styled(Container)`
  margin-top:15vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
 
`
const MainText = styled.h1`
  font-style: italic;
  text-align:${props => props.align};
  font-size: ${props => props.size}px;
  line-height: ${props => props.height || "128.9%"};
  width:${props => props.width};
  color: rgba(255, 255, 255, 0.22);

  @media only screen and (max-width: 767px) {
    font-size: ${props => props.sizeM || "40"}px;
    // margin-left:17vw;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size: ${props => props.sizeM || "40"}px;
    // margin-left:17vw;
  }
`
const SubText = styled.h3`
  text-align:left;
  font-weight: bold;
  font-size: 55px;
  width:${props => props.width};
`
const SubTextM = styled.h3`
  text-align:center;
  font-weight: bold;
  font-size: 35px;
  // margin-left:17vw;
  line-height:130%;

`
const CustomTextDeco = styled.h3`
  text-align:left;
  font-weight: regular;
  font-size: 35px;
  display:inline-block;
  @media only screen and (max-width: 767px) {
    font-size:28px;
    line-height:150%;
    text-align:center;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size:28px;
    line-height:150%;
    text-align:center;
  }
`
const SpecialItalic = styled.h3`
  font-style: italic;
  font-size: ${props => props.size || "35"}px;
  color: #36FFC1;
  display:inline-block;
  @media only screen and (max-width: 767px) {
    font-size:30px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    font-size:30px;
  }
`
const RightAlign = styled.div`
  margin-top:15vh;
  display: flex;
  justify-content: flex-end;
  @media only screen and (max-width: 767px) {
    padding-right:20px;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    padding-right:20px;
  }
`
const RightAlignSubText = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-right:8vw;

  @media only screen and (min-width: 768px) {
    margin-right:8vw;
  }

  @media only screen and (max-width: 767px) {
    margin-right:20vw;
  }

  @media only screen and (max-width: 767px) and (orientation: portrait) {
    margin-right:20vw;
  }
`
const CustomRow = styled(Row)`
  // border: thick double #32a1ce;
`
const CustomColumn = styled(Row)`
  width:260px;
`
const ReverseText = styled.h2`
  transform: matrix(-1, 0, 0, 1, 0, 0);
  font-style: italic;
  color: ${props => props.color};
  font-size: ${props => props.size};
  line-height: 80.9%;
`
const ImageContainer = styled.span`
position: relative;
width: 100%;
`
const CustomImage = styled.img`
position:absolute;
display: block;
top:-10vh;
left:5vw;
height: 350px;
//350px

`


const ImageOverText = styled.text`
  color: black;
  font-style: italic;
  font-weight: normal;
  font-size: 60px;
  color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%
  
`

const Deco = styled.div`
background: #36FFC1;
height:28px;
display: flex;
    align-items: flex-end;
    justify-content: end;

    @media only screen and (max-width: 767px) {
     height:12px;
    }
    
    @media only screen and (max-width: 767px) and (orientation: portrait) {
      height:12px;
    }
`
const DecoParent = styled.div`
display:inline-block;
`

const ScrollRow = styled(Row)`
@media only screen and (min-width: 768px) {
  /* tablets and desktop */
}

@media only screen and (max-width: 767px) {
  margin-top:10vh;
}

@media only screen and (max-width: 767px) and (orientation: portrait) {
  margin-top:25vh;
}
margin-top:20vh;
`
const ScrollDeco = styled.img`
  height:150px;
`

const MobileView = styled.div`



`

const Wrapper = styled(Container)`
padding:40px;
@media only screen and (max-width: 767px) {
  margin-left:20px;
  padding:40px;
 }
 
 @media only screen and (max-width: 767px) and (orientation: portrait) {
  padding:40px;
  margin-left:20px;
 }
`
//////////////////////////////
//Component class
/**
 * Displays a Hero Section component
 */
function HeroSection(props) {
  const [visible, setVisible] = useState(false);
  const [inHover, setHover] = useState(false);

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 992 })
    return isDesktop ? children : null
  }
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 991 })
    return isTablet ? children : null
  }
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 })
    return isMobile ? children : null
  }
  const Default = ({ children }) => {
    const isNotMobile = useMediaQuery({ minWidth: 768 })
    return isNotMobile ? children : null
  }

  const RenderMobileSubSection = ()=>{
    return (
      <MobileView>
          <MainText size={80} align="center">
              I am
          </MainText>
          <SubTextM>
              Striving<br />
              <CustomTextDeco>
                to help humans be <br />
              the best version <br />of themselves <br />
              through <SpecialItalic>
                  <RandomReveal
                    isPlaying
                    duration={2}
                    revealDuration={0.7}
                    characters="design"
                    onComplete={() => [true, 1000]}
                  />
                </SpecialItalic> & <SpecialItalic>
                  <RandomReveal
                    isPlaying
                    duration={2}
                    revealDuration={0.7}
                    characters="code"
                    onComplete={() => [true, 1000]}
                  /></SpecialItalic>.
            </CustomTextDeco>
            </SubTextM>
      </MobileView>

    )
  }

  const RenderSubSection = () => {
    return (
      <DescWrapper>
        <CustomRow>
          <Col>
            <MainText md={{ span: 2, offset: 2 }} size={120} height="70%" width="max-content">
              I am
          </MainText>
          </Col>
          <Col >
          </Col>
        </CustomRow>
        <CustomRow>
          <Col>
          </Col>
          <Col md={{ span: 6, offset: 3 }}>
            <SubText width="max-content">
              Striving<br />
              <CustomTextDeco>
                to help humans be <br />
              the best version of themselves <br />
              through <SpecialItalic>
                  <RandomReveal
                    isPlaying
                    duration={2}
                    revealDuration={0.7}
                    characters="design"
                    onComplete={() => [true, 1000]}
                  />
                </SpecialItalic> & <SpecialItalic>
                  <RandomReveal
                    isPlaying
                    duration={2}
                    revealDuration={0.7}
                    characters="code"
                    onComplete={() => [true, 1000]}
                  /></SpecialItalic>.
            </CustomTextDeco>
            </SubText>
          </Col>
        </CustomRow>
      </DescWrapper>
    );
  }

  const Child = () => {
    return (
      <ImageContainer>
        <CustomImage src={Melb} />
      </ImageContainer>
    )
  }


  const VisibleText = () => {
    return " Melbourne"
  }

  return (
    <React.Fragment>
      {/* main heading */}
      <FullHeightContainer>
        <HeroWrapper>
          <Row>
            <HeadingWrapper
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
                duration: 2,
                ease: "easeIn"
              }}
            >
              <HeroText>
                hi there,<br />
                  i'm <DecoParent>
                  <Deco>gayuru !</Deco>
                </DecoParent>
              </HeroText>
              {/* <HeadingDeco /> */}
            </HeadingWrapper>
          </Row>
          <Row>
            <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{
              duration: 2,
              ease: "easeIn",
              delay: 1
            }}>
              <HeroSubheading>
                a software developer<br />
              based in 
              <span
                  onMouseEnter={() => setHover(true)}
                  onMouseLeave={() => setHover(false)}
                >
                  Melbourne
              </span>
                {inHover && <Child />}
                <br />
                {/* <span onMouseEnter={() => setVisible(true)} onMouseLeave={() => setVisible(false)}>
                {visible && <Child />}{!visible && <VisibleText />}
              </span>,<br /> */}
              Australia
          <SubHeadingDeco>
                  .
          </SubHeadingDeco>
              </HeroSubheading>
            </motion.div>
          </Row>
          <ScrollRow>
          <motion.div
            animate={{ rotate: 360 }}
            transition={{
              duration: 13,
              loop: Infinity,
              ease: "linear",
            }}
          >
            <ScrollDeco src={ScrollSvg} />
          </motion.div>
        </ScrollRow>

        </HeroWrapper>
        
      </FullHeightContainer>

      <CustomHeightContainer>
      <Desktop>{RenderSubSection()}</Desktop>
      <Tablet>{RenderSubSection()}</Tablet>
      <Mobile>{RenderMobileSubSection()}</Mobile>
      {/* <Default>{RenderSubSection()}</Default> */}
        
    
        {/* {isTabletOrMobileDevice && RenderMobileSubSection()} */}
      </CustomHeightContainer>
      <HalfHeightContainer>
        <Wrapper>
          <CustomRow>
            <MainText size={120} sizeM={80} align="left" height="50%">
              Let’s
           </MainText>
          </CustomRow>
          <CustomRow>
            <MainText size={60} align="left">
              jump straight in...
          </MainText>
          </CustomRow>

          <RightAlign>
            <HeroSubheading align="right">
              Shall we<SpecialItalic size="50">?</SpecialItalic>
            </HeroSubheading>
          </RightAlign>

          <RightAlignSubText>
            <MainText size={110}sizeM={80} height="80.9%">
              YES
            </MainText>
          </RightAlignSubText>
          <RightAlignSubText>
            <ReverseText color="rgba(255, 255, 255, 0.68)" size="64px">
              YES
            </ReverseText>
          </RightAlignSubText>
          <RightAlignSubText>
            <ReverseText color="#FFFFFF" size="38px">
              YES
            </ReverseText>
          </RightAlignSubText>
        </Wrapper>
      </HalfHeightContainer>

    </React.Fragment>
  )
}
export default HeroSection;